import Button from 'shared/components/form/button';
import './styles.scss';

interface EventStatusProps {
	title: string;
	buttonText: string;
	link: string;
}
export const EventStatus = ({ buttonText, link, title }: EventStatusProps) => (
	<div className="eventStatus">
		<h2 className="eventStatus__title">{title}</h2>
		<Button btnType="primary" link={link}>
			{buttonText}
		</Button>
	</div>
);

export default EventStatus;
